import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PlatformProvider } from './contexts/PlatformContext';
import { AppShell } from './components/layout/AppShell';
import { Dashboard } from './pages/Dashboard';
import { Applications } from './pages/Applications';
import { ApplicationReview } from './pages/ApplicationReview';
import { PortfolioBoard } from './pages/PortfolioBoard';
import { LifecycleWorkspace } from './pages/LifecycleWorkspace';
import { AiHub } from './pages/AiHub';
import { Reports } from './pages/Reports';
import { Outreach } from './pages/Outreach';
import { Registry } from './pages/Registry';
import { Toaster } from './components/ui/Sonner';
export function App() {
  return <PlatformProvider data-id="element-0" data-mp="2wiywor52xrb5">
      <BrowserRouter data-id="element-1" data-mp="2wip6b2g4hi4x">
        <Routes data-id="element-2" data-mp="2wi5lndz38fn7">
          <Route element={<AppShell data-id="element-4" data-mp="28tw972nrl48q" />} data-id="element-3" data-mp="28u5xmlt5v3cb">
            <Route path="/" element={<Dashboard data-id="element-6" data-mp="28sbb5328r364" />} data-id="element-5" data-mp="28t4ju9krg2qw" />
            <Route path="/applications" element={<Applications data-id="element-8" data-mp="23u9q4cl98ts0" />} data-id="element-7" data-mp="23vkw8j26adma" />
            <Route path="/applications/:id" element={<ApplicationReview data-id="element-10" data-mp="3ikh7o8icgqyg" />} data-id="element-9" data-mp="23t8hsfvmildz" />
            <Route path="/lifecycle" element={<PortfolioBoard data-id="element-12" data-mp="3ii4ro0w5cqo1" />} data-id="element-11" data-mp="3ijfwm41bw4gq" />
            <Route path="/lifecycle/:id" element={<LifecycleWorkspace data-id="element-14" data-mp="3mjztd6hzp62c" />} data-id="element-13" data-mp="3ml17jjuay8oa" />
            <Route path="/intelligence" element={<AiHub data-id="element-16" data-mp="3rdaq2et386gj" />} data-id="element-15" data-mp="3rc9ca2kot5v4" />
            <Route path="/reports" element={<Reports data-id="element-18" data-mp="5yjsutqtdfe" />} data-id="element-17" data-mp="3rcsuzli5vya7" />
            <Route path="/outreach" element={<Outreach data-id="element-20" data-mp="5gfrc0u9uwx" />} data-id="element-19" data-mp="6htjo98ovic" />
            <Route path="/registry" element={<Registry data-id="element-22" data-mp="2zlldgx6hkckm" />} data-id="element-21" data-mp="7sulgbavp5r" />
            <Route path="*" element={<Dashboard data-id="element-24" data-mp="2zmwlj96ys6hj" />} data-id="element-23" data-mp="2zmeoiach9o8k" />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton data-id="element-25" data-mp="33n6yx6x35z6f" />
    </PlatformProvider>;
}